import { render, staticRenderFns } from "./CaregiverBehaviorRating.vue?vue&type=template&id=2fd32cce&scoped=true"
import script from "./CaregiverBehaviorRating.vue?vue&type=script&lang=js"
export * from "./CaregiverBehaviorRating.vue?vue&type=script&lang=js"
import style0 from "./CaregiverBehaviorRating.vue?vue&type=style&index=0&id=2fd32cce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd32cce",
  null
  
)

export default component.exports